import React, { useState, useMemo } from 'react';
import HoldProHeader from '../common/GridHeader';
import TabContainer from '../common/TabContainer';
import DeleteFromHoldList from '../DeleteFromHoldList';
import AddToHoldList from '../AddToHoldList';
import { withStyles } from '@material-ui/core';
import styles from '../styles';
import { defaultTabConfig  } from '../common/Constants';

const CustomerHolds = ({ classes, holdData, errorMessage, updateHoldData, enabledTabs }) => {
  const [tabId, setTabId] = useState(0);
  const [gridApi, setGridApi] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [isAddFormOpen, setIsAddFormOpen] = useState(false);
  const [selectedGridData, setSelectedGridData] = useState([]);
  const [selectedDataToDelete, setDataSelected] = useState([]);
  
  // Filter tabs based on tabConfigs
  const tabConfig = useMemo(() => {
    return defaultTabConfig ?.filter((tab) => {
      return enabledTabs[tab.flag];
    });
  }, [enabledTabs]);

  const handleTabChange = (event, newTabId) => {
    if (tabId !== newTabId) {
      setTabId(newTabId);
      setDataSelected([]);
      setSelectedGridData([]);
      setSearchText('');
      setIsAddFormOpen(false);
    }
  };
  const setGridsApi = (value) => {
    setGridApi(value);
  };
  const onDeleteData = (selectedPro) => {
    setDataSelected(selectedPro);
  };

  const onCancelDelete = () => {
    setDataSelected([]);
  };

  const isExistingData = (code) => {
    const datalist = holdData[tabConfig[tabId].dataListKey];
    return datalist?.some((data) => data[tabConfig[tabId].getApiCode] === code);
  };

  const updateHoldDataWithTabId = () => {
    updateHoldData();
  };

  return (
    <>
      <HoldProHeader
        handleTabChange={handleTabChange}
        tabId={tabId}
        gridApi={gridApi}
        searchText={searchText}
        setSearchText={setSearchText}
        isAddFormOpen={isAddFormOpen}
        setIsAddFormOpen={setIsAddFormOpen}
        selectedData={selectedGridData}
        onDeleteData={onDeleteData}
        tabNames={tabConfig.map((tab) => tab.gridName)}
      />
      <TabContainer
        tabId={tabId}
        dataList={holdData}
        setGridApi={setGridsApi}
        showErrorMessage={errorMessage}
        dataSelectedOnGrid={setSelectedGridData}
        selectedData={selectedGridData}
        searchText={searchText}
        tabConfig={tabConfig}
      />
      {selectedDataToDelete.length > 0 && (
        <DeleteFromHoldList
          onCancel={onCancelDelete}
          selectedData={selectedDataToDelete}
          gridName={tabConfig[tabId].name}
          label={tabConfig[tabId].postApiCode}
          updateHoldData={updateHoldDataWithTabId}
        />
      )}
      {isAddFormOpen && (
        <AddToHoldList
          tabConfig={tabConfig[tabId]}
          open={isAddFormOpen}
          drawerClasses={{ paper: classes.addHoldListPaperAnchor }}
          variant="persistent"
          onClose={setIsAddFormOpen}
          updateHoldData={updateHoldDataWithTabId}
          isExistingData={isExistingData}
          tabId={tabId}
        />
      )}
    </>
  );
};

export default withStyles(styles)(CustomerHolds);
